import React, { Component } from "react";
import authService from "../../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import HabilitarAhorroProgramadoService from "../../../../services/autogestion/HabilitarAhorroProgramadoService";
import Popup from "react-popup";
import TecladoPin from "../../../generico/TecladoPin";
import { ModalPinTransaccional } from "../../../generico/ModalPinTransaccional";


export default class TuMetaEsLaNuestraPaso2 extends Component {

  constructor(props) {
    super(props);
    this.filterInput = React.createRef();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    pin: "",
    datosCuenta: [],
    toggle: true,
    porSuerte: false,
    nroContrato: -1,
    cuentaOrigen: {},
    plan: {},
    nombreCompletoSocio: authService.getSocio().nombreCompleto.trim(),
    disableSgte: true,
    aceptaTerminos: false,
  });


  pinValue = (value) => {
    this.setState({
      pin: value,
    },
    this.enableNext
  );
   
  };

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidUpdate(prevProps, prevState) {

    console.log("prevState update", prevState);
    console.log("terminos update", this.state.aceptaTerminos);
    console.log("pin update", this.state.pinValue);
    console.log("terminos props", this.props);
    if ((prevState.aceptaTerminos !== this.state.aceptaTerminos)) {

      this.enableNext();

    };


  }


  handleCheckboxChange = () => {
    this.setState({
      aceptaTerminos: !this.state.aceptaTerminos
    })
    console.log('valor terminos ', this.state.aceptaTerminos);

  };

  enableNext() {
    this.setState({ disableSgte: true });
    if (this.state.aceptaTerminos ) {
      this.state.disableSgte = false;
    } else {
      this.state.disableSgte = true;
    }
    if (this.state.aceptaTerminos ) {
      this.setState({ disableSgte: false });
    }
  }

  



  confirmar = (e) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.monto.split('.').join('');
    importe = String(importe).replace(/\,/g, ".");

    let data = {

      canal: "CU24HS_WEB",
      idMoneda: "GS",
      idModalidad: this.props.plan.idModalidad,
      importe: importe,
      cuentaDebito: this.props.cuentaOrigen.ahorro,
      etiquetaCuenta:this.props.nombre

    }

    trackPromise(
      HabilitarAhorroProgramadoService.aperturaCuentaAhorroProgramado(data)
        .then((response) => {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);

          if (jData !== undefined && jData.codigo !== null) {
            if (jData.codigo === 0) {
              this.props.returnDataPaso2(this.props.cuentaOrigen, jData.datos.idAhorro, jData.datos.fechaVencimiento,jData.datos.idMovimiento);
              this.nextStep.click();
            } else {
              Popup.queue(this.notifiPopup("Atención", jData.mensaje));
            }
          } else {
            Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
          }
        })
    ).catch(function (error) {
      console.log(error)
      this.btn.removeAttribute("disabled");
      Popup.queue(Popup.register({
        title: "Error Inesperado.",
        content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
        buttons: {
          right: [
            {
              text: "Aceptar",
              className: "success",
              action: function () {
                Popup.close();
              },
            },
          ],
        },
      }));
    });
  }
  descargarContrato = async () => {
    
    await trackPromise(
      HabilitarAhorroProgramadoService.descargarContratoMeta(this.props.idAhorro)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  render() {

    const columns = [
      {
        name: "concepto",
        selector: "concepto",
      },
      {
        name: "valor",
        selector: "valor",
      },
    ];

    

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">1</span>
                    <span className="title_text">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="number current">2</span>
                    <span className="title_text current">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">3</span>
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-8">
            <section className="content">
              <div className="container-fluid">
                {/* <div className="row">
                    <div className="col-md-8">
                    <label className="input-label">
                      Cuenta Origen (a debitar): 
                    </label>
                    <br/>
                      <span>
                      {this.props.cuentaOrigen.ahorro} - {this.state.nombreCompletoSocio}
                      </span>
                      <div className="inner"style={{paddingTop: 2,paddingBottom: 1,}}>
                        <h6 style={{ margin: 0 }}>
                          Tipo: {this.props.cuentaOrigen.descripcion}
                        </h6>
                        <p style={{ margin: 1 }}>
                          Moneda: {this.props.cuentaOrigen.moneda}
                        </p>
                      </div>
                    </div>                    
                  </div> */}

                <div className="row">

                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Cuenda Débito Seleccionado:</th>
                          <td>{this.props.cuentaOrigen.ahorro} - {this.props.cuentaOrigen.descripcion}</td>
                        </tr>
                        <tr>
                          <th>Plan Seleccionado:</th>
                          <td>{this.props.plan.descripcion}</td>
                        </tr>
                        <tr>
                          <th>Tasa de Interés (%):</th>
                          <td>{this.props.plan.interes}</td>
                        </tr>
                        <tr>
                          <th>Importe mensual:</th>
                          <td>{this.props.monto}</td>
                        </tr>
                        <tr>
                          <th>Importe Aproximado a Percibir:</th>
                          <td>{this.props.montoFinal}</td>
                        </tr>
                        <tr>
                          <th>Nombre:</th>
                          <td>{this.props.nombre}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                <br />
               
              
              </div>
            </section>
          </div>
          
        </div>
        <div className="col-md-12">
         

          <div className="row">
            <div className="col-12">
              <div className="card"
                style={{
                  padding: 4,
                  border: "1px solid #007c34",
                  color: "rgb(58, 58, 58)",
                  boxShadow: "none",
                }}>
                <p>
                  Declaro bajo la fe de Juramento que los fondos de
                  todas las operaciones y transacciones que realizo
                  o realizaré con la <strong>UNIVERSITARIA LTDA. </strong>
                  durante mi vinculación comercial con la
                  Institución, cualquiera sea su naturaleza,
                  denominación, condición o modalidad de las mismas,
                  provienen y/o provendrán de fuentes lícitas
                </p>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-md-8">
            <div className="row float-right">
              <label className="input-label-bold float-left" style={{ marginTop: 10, marginRight: 15}}>
                Esta seguro que desea CONFIRMAR la operación? <br />
              </label>
            </div>
          </div>


          <div className="col-md-2">
            <button
              onClick={this.props.previousStep}
              type="button"
              className="btn btn-cu-secundary float-right"
              style={{ marginRight: "5px" }}>
              Volver
            </button>
          </div>
          <div className="col-md-2">
            <button ref={btn => { this.btn = btn; }}
              data-toggle="modal"
              data-target="#modal-pin-extracto"
              //disabled={this.state.disableSgte}
              className="btn btn-cu-primary"
            >
              Confirmar
            </button>
            <ModalPinTransaccional id="modal-pin-extracto" onSuccess={this.confirmar} />
          </div>
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}></button>
          <button
            hidden
            ref={(a) => (this.previousStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.previousStep}></button>
        </div>
      </div>


    );
  }
}

